<template>
  <div class="wrapper">
    <div>
      <div
        style="height: 80px"
        class="livehead"
        :style="{ 'background-color': $store.getters.setting.bgColor }"
      >
        <template v-if="$store.getters.setting.logo">
          <img :src="publicUrl($store.getters.setting.logo)" style="max-height: 50px" />
        </template>
        <template v-else>
          {{ $store.getters.setting.projectName }}
        </template>
      </div>
    </div>
    <div class="text-center ma-3 mt-0 grey lighten-4 pb-8" style="border-radius: 10px">
      <div class="text-left px-9 pt-8 pb-5">
        <div class="primary--text" style="font-size: 18px">ยินดีต้อนรับสู่ทรูไอดี</div>
        <div class="caption grey--text" style="font-family: 'Kanit', sans-serif !important">
          ค้นพบความบันเทิงและสิทธิพิเศษจากทรูไอดี
        </div>
      </div>
      <ValidationObserver ref="observer">
        <div class="mt-5 px-9">
          <v-row justify="center">
            <v-col class="pa-0" lg="12">
              <!-- <div class="label-text primary--text">ชื่อผู้ใช้</div> -->

              <ValidationProvider name="ชื่อผู้ใช้" :rules="'required'" v-slot="{ errors }">
                <v-text-field
                  label="ชื่อผู้ใช้"
                  outlined
                  v-model="input.name"
                  required
                  style="padding: 0; margin: 0"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col class="pa-0" lg="12">
              <!-- <div class="label-text primary--text">เบอร์โทรศัพท์</div> -->
              <ValidationProvider
                name="เบอร์โทรศัพท์"
                :rules="'required|thai_phonenumber'"
                v-slot="{ errors }"
              >
                <v-text-field
                  label="เบอร์โทรศัพท์"
                  outlined
                  v-model="input.phoneNumber"
                  required
                  style="padding: 0; margin: 0"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <div>
            <v-btn
              :loading="loading"
              @click="signin"
              color="primary"
              style="margin-top: 15px; font-size: 14px"
              dark
              block
              >ถัดไป</v-btn
            >

            <div
              class="caption mt-4 text-left grey--text"
              style="font-family: 'Kanit', sans-serif !important"
            >
              การคลิกสร้างบัญชีเป็นการแสดงว่าคุณยอมรับ ข้อกำหนดและเงื่อนไข และนโยบายความเป็นส่วนตัว
            </div>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
export default {
  data() {
    return {
      input: {
        username: '',
        password: ''
      },
      loading: false,
      rememberme: false
    }
  },
  beforeCreate() {
    this.$store.state.bgcolor = '#efefef'
  },
  beforeDestroy() {
    this.$store.state.bgcolor = 'white'
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },

  methods: {
    async signin() {
      if (await this.$refs.observer.validate()) {
        this.loading = true
        let data = {
          first_name: this.input.name,
          phoneno: this.input.phoneNumber,
          pageid: this.$store.getters.setting.pageid
        }
        axios
          .get(`${this.$store.getters.setting.serverUrl}warroom/webchat/login`, {
            headers: {
              AUTHORIZATION: this.$store.getters.accessToken
            },
            params: data
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              this.$store.state.id = response.data.data[0].id
              localStorage.setItem('id', this.$store.state.id)
              await this.chatlog(this.$store.state.id, this.$store.getters.setting.pageid)
              this.$store.state.isJustLogin = true

              this.$store.commit('SET_LOGIN_STATUS', true)
            }
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: block;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 10px;
}
.livehead {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  color: white;
  text-align: center;
  font-size: 24px;
  line-height: 26px;
  padding-top: 12px;
}
.label-text {
  font-size: 14px;
  text-align: left;
}
</style>
